import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../core/router/all_routes";
import api from "../../../core/api/config";
import GovHeader from "../../components/GovHeader";
import BotaoAjuda from "../../components/BotaoAjuda";

const Resetpassword = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const location = useLocation();

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (password !== passwordConfirm) {
      setError("As senhas não coincidem.");
      return;
    }

    try {
      await api.post("/api/password/reset", {
        token,
        email,
        password,
        password_confirmation: passwordConfirm,
      });
      setMessage("Senha redefinida com sucesso! Redirecionando...");
      setTimeout(() => navigate(route.signin), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "Erro ao redefinir senha.");
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <GovHeader />
        <div className="login-wrapper login-new">
          <div className="login-content user-login">
            <div className="login-logo">
              <img src="/assets/img/logo.png" alt="Logotipo ConeCta-SP" />
              <Link to={route.dashboard} className="login-logo logo-white">
                <img
                  src="/assets/img/logo-white.png"
                  alt="Logotipo brando do ConeCta-SP"
                />
              </Link>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="login-userset">
                <div className="login-userheading">
                  <h3>Redefinir senha?</h3>
                  <h4>Digite a nova senha e confirme para entrar.</h4>
                </div>

                <div className="form-login">
                  <label>Nova Senha:</label>
                  <div className="pass-group position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="pass-input"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <span
                      className={`fas toggle-password ${
                        showPassword ? "fa-eye" : "fa-eye-slash"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    />
                  </div>
                </div>

                <div className="form-login">
                  <label>Confirmar Nova Senha:</label>
                  <div className="pass-group position-relative">
                    <input
                      type={showPasswordConfirm ? "text" : "password"}
                      className="pass-input"
                      value={passwordConfirm}
                      onChange={(e) => setPasswordConfirm(e.target.value)}
                      required
                    />
                    <span
                      className={`fas toggle-password ${
                        showPasswordConfirm ? "fa-eye" : "fa-eye-slash"
                      }`}
                      onClick={() =>
                        setShowPasswordConfirm(!showPasswordConfirm)
                      }
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    />
                  </div>
                </div>

                {message && <p className="text-success">{message}</p>}
                {error && <p className="text-danger">{error}</p>}

                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                    Redefinir senha
                  </button>
                </div>
              </div>
            </form>
            <div className="signinform text-center mt-3">
              <h4>
                Retornar para a página de
                <Link to={route.signin} className="hover-a">
                  {" "}
                  login{" "}
                </Link>
              </h4>
            </div>
            <div className="login-logo mt-3">
              <img
                src="/assets/img/logo-fosp.png"
                alt="Logotipo FOSP"
                width="100px"
              />
            </div>
          </div>
        </div>
        <BotaoAjuda />
      </div>
    </div>
  );
};

export default Resetpassword;
